// Auto-delete service for chat messages
import { supabase } from '@/integrations/supabase/client';
import { ChatService } from './chatService';

class AutoDeleteService {
  private static instance: AutoDeleteService;
  private intervalId: ReturnType<typeof setInterval> | null = null;
  private readonly CHECK_INTERVAL = 1000 * 60 * 60 * 6; // Check every 6 hours (reduced DB load)

  private constructor() {
    // Private constructor to enforce singleton
  }

  public static getInstance(): AutoDeleteService {
    if (!AutoDeleteService.instance) {
      AutoDeleteService.instance = new AutoDeleteService();
    }
    return AutoDeleteService.instance;
  }

  public startAutoDeleteJob() {
    if (this.intervalId) {
      console.log('Auto-delete job is already running');
      return;
    }

    console.log('Starting auto-delete job');
    
    // Run immediately on start
    this.runAutoDelete();

    // Then set up interval
    this.intervalId = setInterval(() => {
      this.runAutoDelete();
    }, this.CHECK_INTERVAL);
  }

  public stopAutoDeleteJob() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
      console.log('Auto-delete job stopped');
    }
  }

  private async runAutoDelete() {
    try {
      // Get all site offices with auto-delete enabled
      const { data: settings, error } = await supabase
        .from('chat_settings')
        .select('site_office_id, auto_delete_period')
        .eq('auto_delete', true);

      if (error) {
        console.error('Error fetching auto-delete settings:', error);
        return;
      }

      if (!settings || settings.length === 0) {
        return; // No site offices have auto-delete enabled
      }

      // Run auto-delete for each site office using admin-configured period
      for (const setting of settings) {
        try {
          const deletedCount = await ChatService.runAutoDelete(
            setting.site_office_id
          );
          
          if (deletedCount > 0) {
            console.log(`Auto-deleted ${deletedCount} messages for site office ${setting.site_office_id}`);
          }
        } catch (err) {
          console.error(`Error auto-deleting messages for site office ${setting.site_office_id}:`, err);
        }
      }
    } catch (error) {
      console.error('Error in auto-delete job:', error);
    }
  }
}

// Export singleton instance
export const autoDeleteService = AutoDeleteService.getInstance();
